module.exports = __webpack_public_path__ + "media/images/facebook_cover_image-05576dee700cf867596d7b4eb8609aad.png";